import React, { useEffect, useState } from "react";
import { Col, Container, ListGroup, Row, Spinner } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import LightGallery from "lightgallery/react";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";

import { ImageElement } from "components";

import userRouteMap from "routes/User/userRouteMap";
import { BROKER_ENDPOINT } from "apiEndpoints";
import { commonService } from "services/common.service";
import socketEventManager from "socket/socketEvents";
import { removeBordersFromCursorPointerImages } from "utils/helpers";

function CategoryDetails(props) {
  const {
    title,
    subTitle,
    backUrl = "/",
    // isNavigate,
    isChildren,
    isMediaView,
    isBottomBack,
    isTopBack,
    isParentImage = false,
  } = props;
  const navigate = useNavigate();
  const location = useLocation();
  
  // Check if private mode is enabled
  const localValue = localStorage.getItem("privateMode");
  const isPrivateMode = localValue === "true";
  
  const [state, setState] = useState({
    isLoading: true,
    lists: [],
    activeChild: null,
    media: [],
  });

  const getCategoryDetails = async () => {
    try {
      const response = await commonService({
        apiEndPoint: BROKER_ENDPOINT.getCategoryDetails(location.state?.id),
      });
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
        lists: response?.data?.data ?? [],
        activeChild: {
          parentIndex: 0,
          childIndex: 0,
          imageUrl:
            response?.data?.data?.[0]?.child_category?.[0]?.media?.path ?? null,
        },
        media: isMediaView
          ? response?.data?.data?.[0].child_category?.map?.(
              (item) => item.media,
            )
          : [],
      }));
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  };

  const getChildrenContent = (lists, parentIdx) => {
    return (
      lists.length > 0 && (
        <div className="d-flex flex-wrap subList justify-content-center">
          {lists.map((listItem, listItemIdx) => (
            <Link
              key={listItemIdx}
              className={`subList_tab ${
                state.activeChild?.parentIndex === parentIdx &&
                state.activeChild?.childIndex === listItemIdx
                  ? "active"
                  : ""
              }`}
            >
              {listItem.name}
            </Link>
          ))}
        </div>
      )
    );
  };

  const handleOnLoadSocketCommand = (item) => { 
    console.log("item", item);
    const object = {
      hardware_id: item?.parent_category?.hardware_id,
      broker_id: item?.parent_category?.broker_id,
      sub_sub_category_id: item?.parent_category?.sub_sub_category_id,
      type : "gallery_image",
      image_id : item?.parent_category?.id,
      image_url : item?.parent_category?.category_image,
    }    
    socketEventManager.sendCommand(item?.parent_category?.hardware_id, object);
  } 

  const handleImageClick = (thisImage) => {
    removeBordersFromCursorPointerImages();
    thisImage.classList.add('bordered');
  }

  useEffect(() => {
    if (!location.state) {
      navigate("/");
    } else {
      getCategoryDetails();
    }
  }, []);

  return (
    <div className="modelGallery">
      <Container fluid className="p-0">
        {isTopBack && (
          <Link
            className="commonBack commonBack_topLeft text-uppercase d-block h-auto position-absolute z-1"
            to={{ pathname: backUrl }}
            state={location.state}
          >
            <em className="icon-back" />
            <span className="d-block">Back</span>
          </Link>
        )}
        <Row className="gx-0">
          {isMediaView ? (
            <>
              {state.isLoading ? (
                <div className="d-flex justify-content-center align-items-center m-auto">
                  <Spinner />
                </div>
              ) : !state.isLoading && state.media?.length > 0 ? (
                <Col md={6} className="pe-lg-5">
                  <div className="imgGrid imgGrid-full position-relative d-flex flex-column align-items-center">
                    <div className="imgGrid_inner d-flex flex-column w-100">
                      {isPrivateMode ? (
                        <LightGallery
                          elementClassNames="gallery-container row gx-2 gy-2"
                          speed={500}
                          mobileSettings={{
                            controls: true,
                            showCloseIcon: true,
                            download: true,
                          }}
                          plugins={[lgThumbnail, lgZoom]}
                        >
                          {state.media.map((item, index) => (
                            <a
                              key={index}
                              className="imgGrid_item col-lg-4 col-6"
                              href={item.image_name}
                            >
                              <div className="position-relative">
                                <ImageElement
                                  imageFor="user"
                                  previewSource={item.image_name}
                                  className={`img-fluid ${item?.imageClass}`}
                                  alt="loung-room"
                                />
                                {item.hasVideo && (
                                  <div className="playIcon d-flex align-items-center justify-content-center position-absolute">
                                    <em className="icon-play" />
                                  </div>
                                )}
                              </div>
                              <h3 className="imgGrid_item_label text-uppercase mt-1">
                                {item.get_media?.media_name}
                              </h3>
                            </a>
                          ))}
                        </LightGallery>
                      ) : (
                        <div className="gallery-container row gx-2 gy-2">
                          {state.media.map((item, index) => (
                            <div
                              key={index}
                              className="imgGrid_item col-lg-4 col-6 cursor-pointer"
                            >
                              <div className="position-relative">
                                <ImageElement
                                  imageFor="user"
                                  previewSource={item.image_name}
                                  className={`img-fluid ${item?.imageClass}`}
                                  alt="loung-room"
                                  onClick={(e) => handleImageClick(e.currentTarget)}
                                />
                                {item.hasVideo && (
                                  <div className="playIcon d-flex align-items-center justify-content-center position-absolute">
                                    <em className="icon-play" />
                                  </div>
                                )}
                              </div>
                              <h3 className="imgGrid_item_label text-uppercase mt-1">
                                {item.get_media?.media_name}
                              </h3>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
              ) : (
                <div className="d-flex justify-content-center align-items-center vh-100">
                  No data found
                </div>
              )}
            </>
          ) : (
            <Col md={6}>
              {state.isLoading ? (
                <div className="d-flex justify-content-center align-items-center vh-100">
                  <Spinner />
                </div>
              ) : !state.isLoading &&
                (state.activeChild?.imageUrl || isParentImage) ? (
                <div className="modelGallery_left commonLeftImg">
                  <div className="boxImage">
                    <ImageElement
                      onLoad={() => handleOnLoadSocketCommand(state.lists[0])}
                      imageFor="user"
                      previewSource={
                        state.lists[0]?.parent_category?.category_image ??
                        location.state?.primary_media
                      } 
                      className="w-100"
                      alt="modal-gallery"
                    />
                  </div>
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center vh-100">
                  No data found
                </div>
              )}
            </Col>
          )}
          <Col md={6}>
            <div className="modelGallery_right d-flex flex-column justify-content-between align-items-center h-100vh">
              <header className="header w-100 d-flex align-items-center position-relative">
                <div className="header_title mx-auto">
                  <h1 className="mb-0">{title}</h1>
                </div>
                <Link className="header_logo" to={userRouteMap.LANDING.path}>
                  <ImageElement
                    imageFor="user"
                    source="logo.svg"
                    className="img-fluid"
                  />
                </Link>
              </header>
              <div
                className={
                  !state.isLoading
                    ? "multiList text-center innerScroll px-3"
                    : ""
                }
              >
                {state.isLoading ? (
                  <div className="d-flex justify-content-center align-items-center m-auto">
                    <Spinner />
                  </div>
                ) : !state.isLoading && state.lists.length > 0 ? (
                  <>
                    {subTitle?.length > 0 && (
                      <h2 className="text-uppercase innerHead">GALLERY</h2>
                    )}
                    <ListGroup className="flex-column">
                      {state.lists.map((listItem, idx) => (
                        <ListGroup.Item className="multiList_item" key={idx}>
                          <Link
                            to={
                              userRouteMap?.[
                                listItem.name?.split?.(" ")?.join?.("_")
                              ]?.path
                            }
                            state={listItem}
                            className={`multiList_item_tab ${
                              state.activeChild?.parentIndex === idx
                                ? "active-heading"
                                : ""
                            }`}
                          >
                            {listItem.name}
                          </Link>

                          {isChildren &&
                            listItem?.child_category?.length > 0 &&
                            getChildrenContent(listItem?.child_category, idx)}
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </>
                ) : (
                  <div className="d-flex justify-content-center align-items-center vh-100">
                    No data found
                  </div>
                )}
              </div>
              {isBottomBack && (
                <Link
                  className="commonBack text-uppercase d-block h-auto"
                  to={backUrl}
                  state={location.state}
                >
                  <em className="icon-back" />
                  <span className="d-block">Back</span>
                </Link>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

CategoryDetails.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  backUrl: PropTypes.string,
  // isNavigate: PropTypes.bool,
  isChildren: PropTypes.bool,
  isMediaView: PropTypes.bool,
  isBottomBack: PropTypes.bool,
  isTopBack: PropTypes.bool,
  isParentImage: PropTypes.bool,
};

CategoryDetails.defaultProps = {
  backUrl: "/",
  // isNavigate: true,
  isChildren: false,
  isMediaView: false,
  subTitle: "",
  isBottomBack: false,
  isTopBack: false,
  isParentImage: false,
};

export default CategoryDetails;
